import moment from 'moment'

export const dateWithoutHour = (date: string) => {
  const formattedDate = moment.utc(date).format('DD/MM/YYYY')
  return formattedDate
}

export const toIsoDate = (date: string) => {
  const inputDate = new Date(date)
  const isoDate = inputDate.toISOString().split('T').shift()
  return isoDate + 'T00:00:00.000Z'
}
